module.exports = __webpack_public_path__ + "components/flag/static/square/sn-2794884d811e23940d23f36624153c9a.svg";